import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { EndpointsService, NotificationService } from "../core/services";

@Injectable()
export class BrandLogosService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        BrandLogosService.notificationService = notificationService;
    }

    public getBrandLogos(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, logoUrl: string, height: string, width: string, brandIds: string): Observable<Response> {
        let url = this.getBrandLogosUrl(sortFieldId, sortAsc, pageNumber, pageSize, logoUrl, height, width, brandIds);
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getBrands(): Observable<Response> {
        return this.http.get(`${this.endpointsService.GET_BRANDS_URL}`)
            .catch(this.handleError);
    }

    public createBrandLogo(brandId: number, base64: string, fileUrl: string): Observable<Response> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.endpointsService.CREATE_BRAND_LOGO_URL, { brandId, base64, fileUrl }, options)
            .catch(this.handleError);
    }

    public createBrandAndLogo(brandName: string, base64: string, fileUrl: string): Observable<Response> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.endpointsService.CREATE_BRAND_AND_LOGO_URL, { brandName, base64, fileUrl }, options)
            .catch(this.handleError);
    }

    private getBrandLogosUrl(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, logoUrl: string, height: string, width: string, brandIds: string): string {
        return `${this.endpointsService.GET_BRAND_LOGOS_URL}?sortFieldId=${sortFieldId}&sortAsc=${sortAsc}&logoUrl=${logoUrl}&height=${height}&width=${width}&brandIds=${brandIds}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    }

    public getBrandLogosForBrand(brandId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_BRAND_LOGOS_LIST_URL + "?brandId=" + brandId)
            .catch(this.handleError);
    }

    public deleteBrandLogo(brandLogoId: number) {
        return this.http.delete(this.endpointsService.DELETE_BRAND_LOGO + "?brandLogoId=" + brandLogoId)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            BrandLogosService.notificationService.showError(error.json().message)
        else
            BrandLogosService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }

}


// WEBPACK FOOTER //
// ./src/app/brand-logos/brand-logos.service.ts